const countryCodes = [
  {
    name: "Algeria",
    dialCode: "+213",
    isoCode: "DZ",
  },
  {
    name: "Angola",
    dialCode: "+244",
    isoCode: "AO",
  },
  {
    name: "Australia",
    dialCode: "+61",
    isoCode: "AU",
  },
  {
    name: "Brazil",
    dialCode: "+55",
    isoCode: "BR",
  },
  {
    name: "Canada",
    dialCode: "+1",
    isoCode: "CA",
  },
  {
    name: "Cape Verde",
    dialCode: "+238",
    isoCode: "CV",
  },
  {
    name: "China",
    dialCode: "+86",
    isoCode: "CN",
  },
  {
    name: "Egypt",
    dialCode: "+20",
    isoCode: "EG",
  },
  {
    name: "Eswatini",
    dialCode: "+268",
    isoCode: "SZ",
  },
  {
    name: "Ethiopia",
    dialCode: "+251",
    isoCode: "ET",
  },
  {
    name: "France",
    dialCode: "+33",
    isoCode: "FR",
  },
  {
    name: "Germany",
    dialCode: "+49",
    isoCode: "DE",
  },
  {
    name: "Kenya",
    dialCode: "+254",
    isoCode: "KE",
  },
  {
    name: "Madagascar",
    dialCode: "+261",
    isoCode: "MG",
  },
  {
    name: "Malawi",
    dialCode: "+265",
    isoCode: "MW",
  },
  {
    name: "Mozambique",
    dialCode: "+258",
    isoCode: "MZ",
  },
  {
    name: "Portugal",
    dialCode: "+351",
    isoCode: "PT",
  },
  {
    name: "Qatar",
    dialCode: "+974",
    isoCode: "QA",
  },
  {
    name: "Rwanda",
    dialCode: "+250",
    isoCode: "RW",
  },
  {
    name: "Sao Tome and Principe",
    dialCode: "+239",
    isoCode: "ST",
  },
  {
    name: "South Africa",
    dialCode: "+27",
    isoCode: "ZA",
  },
  {
    name: "Spain",
    dialCode: "+34",
    isoCode: "ES"
  },
];

const countryCodesWithSelectedStatus = countryCodes.map(country => {
  if (country.name === "Mozambique") return { ...country, selected: true };
  return { ...country, selected: false };
});

export default countryCodesWithSelectedStatus;